import React from 'react'
import CollegeFootball from 'src/components/page/college-football'
import { teamIds } from 'src/constants/personalizationIds'
export default (props) => (
  <CollegeFootball
    {...props}
    team="Penn State Nittany Lions"
    hasGenericVideo={true}
    teamId={teamIds['Penn State Nittany Lions']}
  />
)
